module.exports = __webpack_public_path__ + "static/media/YourStoryOurStory-738x57px.b6a115ab.jpg";